module.exports = __webpack_public_path__ + "img/bed-outline-icon.9924108a.svg";